import { useEffect } from "react";
import { useServices, useTuner } from "../../context";
import { Panel } from "../controls";

const GUITAR = [{ name: "E2", midi: 40 }, { name: "A2", midi: 45 }, { name: "D3", midi: 50 }, { name: "G3", midi: 55 }, { name: "B3", midi: 59 }, { name: "E4", midi: 64 }];

/** Chromatic tuner with reference tones (F-PRAC-02). Stops the microphone when it leaves the screen. */
export function Tuner() {
  const { tuner, controller } = useServices();
  const s = useTuner();
  useEffect(() => () => tuner.stop(), [tuner]);
  const r = s.reading;
  const inTune = r !== null && Math.abs(r.cents) <= 5;
  const listening = s.status === "listening";

  return (
    <Panel title="Tuner">
      <div className="controls-row">
        {listening
          ? <button type="button" onClick={() => tuner.stop()}>Stop microphone</button>
          : <button type="button" className="primary" onClick={() => void tuner.start()} disabled={s.status === "starting"}>{s.status === "starting" ? "Starting…" : "Use microphone"}</button>}
        <label className="inline-field">
          <span>A4 =</span>
          <input type="number" min={415} max={466} value={s.a4Hz} aria-label="Reference pitch A4 in hertz" onChange={(e) => { const v = Number(e.currentTarget.value); if (v >= 415 && v <= 466) tuner.setA4(v); }} />
          <span className="unit">Hz</span>
        </label>
      </div>
      {s.message && <p className="status warn" role="alert">{s.message}</p>}
      <div className={`tuner-display ${inTune ? "in-tune" : ""}`} aria-live="polite">
        <div className="tuner-note">{r ? r.name : listening ? "…" : "—"}</div>
        <div className="tuner-gauge" role="meter" aria-label="Tuning offset in cents" aria-valuemin={-50} aria-valuemax={50} aria-valuenow={r?.cents ?? 0}
          aria-valuetext={r ? `${r.name}, ${r.cents > 0 ? "+" : ""}${r.cents.toFixed(0)} cents${inTune ? ", in tune" : r.cents > 0 ? ", sharp" : ", flat"}` : "no pitch"}>
          <span className="tuner-centre" />
          {r && <span className="tuner-needle" style={{ left: `${50 + r.cents}%` }} />}
        </div>
        <div className="tuner-detail">
          {r ? <>{r.cents > 0 ? "+" : ""}{r.cents.toFixed(0)} cents · {r.frequency.toFixed(1)} Hz · {inTune ? "in tune" : r.cents > 0 ? "sharp — tune down" : "flat — tune up"}</> : listening ? "Play a single note." : "Allow the microphone to start tuning."}
        </div>
      </div>
      <div className="controls-row" role="group" aria-label="Reference tones (guitar strings)">
        <span className="hint">Reference:</span>
        {GUITAR.map((g) => (
          <button key={g.name} type="button" onClick={() => controller.previewNotes([g.midi], 2, 0.6, { transpose: false })}>{g.name}</button>
        ))}
      </div>
      <p className="hint">Use headphones for reference tones so the microphone does not hear them. Works best with one clear note at a time.</p>
    </Panel>
  );
}
